import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, forkJoin, Observable, Subject } from 'rxjs';
import { FirebaseAuthService } from '../../user/auth/services/firebase-auth.service';
import { RequestService } from '../../../shared/services/htttp/request.service';
import { Constants } from 'src/app/shared/constant/constants';
import { SessionManagerService } from '../../../shared/services/session/session-manager.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { CommonService, ToastService } from 'src/app/shared/services';
import { cvGetFileData, cvGetFileDataToSave, cvNewFile } from 'src/assets/js/draw';
import { IFileResponse } from 'src/app/shared/models/IFile';
import { AzureAuthService } from '../../user/auth/services/azure-auth.service';
import { CANVAS_DASHBOARD, USER_HOME } from '@app/shared/constant/routes';
import { TranslateService } from '@ngx-translate/core';
import { AssignmentService } from './assignment.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { filterDateTimeStamp } from '@app/shared/helper/utils';
import { CV_COLOR_1 } from '@app/shared/constant/canvasSymTypes';
import { ChooseFilePopupComponent } from '../canvas-dashboard/toolbar-header/choose-file-popup/choose-file-popup.component';
import { GoogleAccessTokenService } from '../../user/auth/services/google-access-token.service';

declare const pdfjsLib: any;
declare const window: any;

@Injectable()
export class FileManagerService {
  private currentFileData = {};
  private openCancelStash: { fileId: string; json: string } | null = null;
  private savedFileData = '';
  private fileId!: string;
  private state!: string;
  private bFileId!: string;
  public currentFileName$ = new BehaviorSubject('');
  public fileSaveInterval: any;
  public shouldSaveFile = false;
  public currentFileUrl = '';
  public parsedCurrentFile!: string | string[];
  public totalPageInPdf = 1;
  public shouldNewFileOpen = false;
  public updateLevel$ = new BehaviorSubject<boolean>(true);
  private loadFailed = false;
  private isFileLoading = false;
  private googleFileData: { fileId: string; googleDriveFileid: string; googleDriveKiwiFileId: string } | null = null;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly firebaseAuthService: FirebaseAuthService,
    private readonly requestService: RequestService,
    private readonly sessionManagerService: SessionManagerService,
    private readonly loaderService: LoaderService,
    private readonly router: Router,
    private readonly flashService: ToastService,
    private readonly firebaseAuth: FirebaseAuthService,
    private readonly azureAuth: AzureAuthService,
    private translateService: TranslateService,
    private assignmentService: AssignmentService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly modalService: BsModalService,
    private readonly commonService: CommonService,
    private readonly googleAccessTokenService: GoogleAccessTokenService,
  ) {
    window.fileManagerService = this;
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * Waits for a *usable* Google token.
   */
  private async waitForGoogleAccessToken(maxAttempts = 120, delayMs = 1000): Promise<string> {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      if (Number(localStorage.getItem('lastGeneratedAccessTokenExpires') || 0) > Date.now()) {
        return this.sessionManagerService.getAccessToken();
      }

      // Renews silently where the platform allows it, otherwise raises the tap prompt.
      // Only on the first pass: repeating it cannot help and would re-arm the prompt.
      if (attempt === 0) {
        this.firebaseAuthService.validateGeneratingAccessToken();
      }
      await this.delay(delayMs);
    }

    return '';
  }

  getCurrentFileName(): string {
    return this.currentFileName$.getValue();
  }

  updateFileId(fileId: string, bFileId: string) {
    localStorage.setItem('LAST_OPENED_FILE', 'Kiwiwrite');
    this.loadFailed = false;
    this.fileId = fileId;
    this.bFileId = bFileId;
    if (this.fileId && this.bFileId) {
      this.sessionManagerService.setFileIdAndBFileId({
        fileId: this.fileId,
        bfileId: this.bFileId,
      });
    }
  }

  updateGoogleDriveFileID(fileId: string, googleDriveFileId: any, googleDriveKiwiFileId: any) {
    this.loadFailed = false;
    this.fileId = fileId;
    localStorage.setItem('LAST_OPENED_FILE', 'Google');
    // Remove old Google FileId details
    this.sessionManagerService.clearGoogleFileId();
    this.googleFileData = null;
    if (this.fileId) {
      this.googleFileData = {
        fileId: fileId,
        googleDriveFileid: googleDriveFileId,
        googleDriveKiwiFileId: googleDriveKiwiFileId,
      };
      this.sessionManagerService.setGoogleFileId(this.googleFileData);
    }
  }

  getCurrentFileId() {
    return {
      fileId: this.fileId,
      bFileId: this.bFileId,
    };
  }

  // This tab's Google file. The cookie is shared by every open tab.
  getCurrentGoogleFileId() {
    return this.googleFileData;
  }
  async resetCurrentFileData(type: any, mathLevel: string | null = null) {
    this.currentFileData = {};
    this.openCancelStash = null;
    this.savedFileData = '';
    const currentMathLevel = this.sessionManagerService.getUserMathLevelId().matheLevelNo;
    const currentFileLevel = sessionStorage.getItem('openFileLevel');
    if (type == 1) {
      //const route = currentMathLevel !== currentFileLevel? ['student/dashboard',this.sessionManagerService.getUserMathLevelId().matheLevelNo]: ['.'];
      const route = ['student/dashboard', mathLevel ? mathLevel : this.sessionManagerService.getUserMathLevelId().matheLevelNo];
      await this.router
        .navigate(route, { queryParams: { fileId: this.fileId ? this.fileId : null, bfileId: this.bFileId ? this.bFileId : null } })
        .then(() => {
          if (currentMathLevel !== currentFileLevel) {
            this.updateLevel$.next(true);
          }
          if (mathLevel) {
            this.updateLevel$.next(true);
          }
        });
    } else {
      const route = ['student/drive', mathLevel ? mathLevel : this.sessionManagerService.getUserMathLevelId().matheLevelNo];
      this.router.navigate(route, { queryParams: {}, queryParamsHandling: 'merge' }).then(() => {
        if (currentMathLevel !== currentFileLevel) {
          this.updateLevel$.next(true);
        }
        if (mathLevel) {
          this.updateLevel$.next(true);
        }
      });
    }
    const tempIsIntegratedWithGoogle = this.sessionManagerService.getisIntegratedWithGoogle();
    if (tempIsIntegratedWithGoogle == 'true') {
      window.location.reload();
    }
  }
  updateCurrentFileData(data: any) {
    if (data) {
      this.currentFileData = JSON.parse(data);
    }
  }
  getCurrentFileData() {
    return this.currentFileData;
  }
  // Called when Open is clicked: keeps the canvas's current file so a Cancel can rebuild from it
  stashFileForOpenCancel() {
    if (this.fileId) {
      this.openCancelStash = { fileId: this.fileId, json: cvGetFileData() };
    }
  }
  createNewFile(
    fileLocation?: any,
    binaryUrlImage = '',
    bitmaps?: string[] | null,
    kiwiJsonData: any = {},
    mathLevelId: string | null = null,
    importedFileName?: string,
  ): Observable<any> {
    return new Observable(sub => {
      this.loaderService.start();
      this.firebaseAuthService
        .addData(kiwiJsonData)
        .then(fRes => {
          // Use imported filename (without extension)
          const fileName = importedFileName ? this.extractFileNameWithoutExtension(importedFileName) : this.generateFileName();

          this.requestService
            .post<{ data: { id: string; fileName: string } }>(Constants.ENDPOINTS.startFile, {
              levelId: mathLevelId ? mathLevelId : this.sessionManagerService.getUserMathLevelId().mathLevelId,
              fileName: fileName,
              fileStatus: Constants.FILE_STATUS.NOT_DONE,
              firebaseFileId: fRes.id,
              fileLocation: fileLocation && {
                location: fileLocation.location,
                eTag: fileLocation.eTag,
                key: fileLocation.key,
              },
            })
            .subscribe(
              res => {
                this.currentFileName$.next(res.data.fileName);
                this.updateFileId(fRes.id, res.data.id);
                const type = 1;
                this.updateFileData(fileLocation?.location, binaryUrlImage, bitmaps);
                this.resetCurrentFileData(type, kiwiJsonData?.mathLevel);
                this.loaderService.stop();
                sub.next(res);
              },
              err => {
                this.loaderService.stop();
                if (err.status == 560 || err.errorMessage == 'Sorry your free trial has expired.') {
                  this.sessionLogout(true);
                }
                sub.error(err.error?.errorMessage ?? err);
              },
            );
        })
        .catch(err => {
          // Without this the loader outlived a failed Firebase write and the caller's progress bar
          // was never told the import had ended.
          this.loaderService.stop();
          console.error('[FileManagerService createNewFile] Could not create the Firebase record:', err);
          sub.error(err);
        });
    });
  }

  deleteFile(): Observable<IFileResponse> {
    return new Observable(sub => {
      this.loaderService.start();
      // this.firebaseAuthService.deleteFileData(this.fileId).then(fRes => {
      this.changeStatusOfFile(Constants.FILE_STATUS.TRASH).subscribe(
        (res: IFileResponse) => {
          this.loaderService.stop();
          this.stopFileSaveOnInterval();
          const { matheLevelNo } = this.sessionManagerService.getUserMathLevelId();
          this.clearCanvasDataAndStates();
          setTimeout(() => {
            this.modalService.show(ChooseFilePopupComponent, {
              backdrop: 'static',
              keyboard: false,
            });
            const url = [`${CANVAS_DASHBOARD.URL}/${matheLevelNo}`];
            this.router.navigate(url);
          }, 500);
          sub.next(res);
        },
        err => {
          sub.error(err);
        },
      );
      // })
    });
  }

  async resetCurrentFileDataInCaseOfSaveAs(type: number, levelNo: number) {
    this.currentFileData = {};
    this.openCancelStash = null;
    this.savedFileData = '';
    const currentMathLevel = levelNo;
    const currentFileLevel = sessionStorage.getItem('openFileLevel');
    if (type == 1) {
      const route = ['student/dashboard', currentMathLevel];
      await this.router
        .navigate(route, { queryParams: { fileId: this.fileId ? this.fileId : null, bfileId: this.bFileId ? this.bFileId : null } })
        .then(() => {
          if (currentMathLevel.toString() !== currentFileLevel) {
            this.updateLevel$.next(true);
          }
        });
    }
    const tempIsIntegratedWithGoogle = this.sessionManagerService.getisIntegratedWithGoogle();
    if (tempIsIntegratedWithGoogle == 'true') {
      window.location.reload();
    }
  }

  createCopyOfAFile(
    fileLocation?: any,
    binaryUrlImage = '',
    bitmaps?: string[] | null,
    data: any = {},
    fileName = '',
    levelId = '',
    levelNo: number | null = null,
  ) {
    return new Observable(sub => {
      this.loaderService.start();
      this.firebaseAuthService.addData(data).then(fRes => {
        this.requestService
          .post<{ data: { id: string; fileName: string } }>(Constants.ENDPOINTS.startFile, {
            levelId,
            fileName: fileName + new Date().toString().split('GMT')[0],
            fileStatus: Constants.FILE_STATUS.NOT_DONE,
            firebaseFileId: fRes.id,
            fileLocation: fileLocation && {
              location: fileLocation.location,
              eTag: fileLocation.eTag,
              key: fileLocation.key,
            },
          })
          .subscribe(
            res => {
              this.currentFileName$.next(res.data.fileName);
              this.updateFileId(fRes.id, res.data.id);
              const type = 1;
              this.updateFileData(fileLocation?.location, binaryUrlImage, bitmaps);
              this.resetCurrentFileDataInCaseOfSaveAs(type, levelNo!);
              this.loaderService.stop();
              sub.next(res);
            },
            err => {
              if (err.status == 560 || err.errorMessage == 'Sorry your free trial has expired.') {
                this.sessionLogout(true);
              }
              sub.error(err.error.errorMessage);
            },
          );
      });
    });
  }

  deleteFilePermanently(isAssigmentFile = false) {
    // Clear Firebase Data

    this.firebaseAuthService.deleteFileData(this.fileId);
    let permanently_delete_file_id: any = '';
    if (this.router.url.indexOf('/drive') > -1) {
      permanently_delete_file_id = this.sessionManagerService.getGoogleFileId().googleDriveKiwiFileId;
    } else {
      permanently_delete_file_id = this.bFileId;
    }

    return isAssigmentFile
      ? this.requestService.delete(`${Constants.ENDPOINTS.files}/${permanently_delete_file_id}/delete-permanently-and-create-copy`)
      : this.requestService.delete(`${Constants.ENDPOINTS.files}/${permanently_delete_file_id}/delete-permanently`);
  }
  saveLastFileDetails() {
    if (this.router.url.indexOf('/drive') > -1) {
      const googleDriveKiwiFileId = this.sessionManagerService.getGoogleFileId().googleDriveKiwiFileId;
      return this.requestService.patch(`${Constants.ENDPOINTS.files}/${googleDriveKiwiFileId}/last-opened-file`);
    } else {
      return this.requestService.patch(`${Constants.ENDPOINTS.files}/${this.bFileId}/last-opened-file`);
    }
  }

  saveFileData(afterReload = false, isNewFileCreated?: boolean, studentFirebaseId = null) {
    if (
      !this.activatedRoute.snapshot.queryParams.fileId &&
      !this.activatedRoute.snapshot.queryParams.bfileId &&
      this.router.url.indexOf('/drive') === -1
    ) {
      return;
    }
    // Nothing is written while a file is still loading: the canvas does not hold it yet, so its
    // data (pageCount 1 and no pages) would overwrite the stored file.
    if (this.loadFailed || this.isFileLoading) {
      return;
    }
    const currentAssignmentData: any = this.assignmentService.getFileData();
    if (currentAssignmentData && currentAssignmentData?.assignmentStatus !== 'ASSIGNED') {
      const userDetails = this.sessionManagerService.getLoggedInData();
      if (userDetails?.userType === '1' || userDetails?.userType === '2' || userDetails?.userType === '4') {
        const { student } = currentAssignmentData!.assignmentPermissions;
        if ((!student.canEdit && student.canView) || (!student.canEdit && !student.canView)) return;
      } else if (userDetails?.userType === '3') {
        const { teacher } = currentAssignmentData!.assignmentPermissions;
        if (!teacher.canEdit && teacher.canView) return;
      }
    }

    this.checkFirebaseEntry(this.fileId);
    if (isNewFileCreated) {
      return;
    }

    const chnagedData = cvGetFileDataToSave() || JSON.stringify(this.currentFileData);

    if (chnagedData !== this.savedFileData || (afterReload && Object.keys(this.currentFileData).length)) {
      if (!afterReload) {
        this.currentFileData = JSON.parse(chnagedData);
      }

      const studentId: any =
        studentFirebaseId ||
        this.activatedRoute?.snapshot.queryParams?.studentFirebaseId ||
        this.router.parseUrl(this.router.url).queryParams?.studentFirebaseId;

      return studentId
        ? this.firebaseAuthService
            .getStudentFile(this.fileId, studentId)
            .then(() => {
              return this.firebaseAuthService.updateStudentFileAsTeacher(this.currentFileData, this.fileId, studentId).then(() => {
                this.savedFileData = chnagedData;
                this.shouldSaveFile = false;
                return true;
              });
            })
            .catch(e => {
              console.log('ERROR OCCURING...');
              console.log('firebase-error', e);
              if (Object.keys(this.currentFileData).length) {
                this.firebaseAuthService.reCreateDataField(this.fileId, this.currentFileData);
              }
              if (e.status == 560 || e.errorMessage == 'Sorry your free trial has expired.') {
                this.sessionLogout();
              }
              return false;
            })
        : this.firebaseAuthService
            .getData(this.fileId)
            .then(() => {
              return this.firebaseAuthService.updateDataInFile(this.currentFileData, this.fileId).then(() => {
                this.savedFileData = chnagedData;
                this.shouldSaveFile = false;
                return true;
              });
            })
            .catch(e => {
              console.log('firebase-error', e);
              if (Object.keys(this.currentFileData).length) {
                this.firebaseAuthService.reCreateDataField(this.fileId, this.currentFileData);
              }
              if (e.status == 560 || e.errorMessage == 'Sorry your free trial has expired.') {
                this.sessionLogout();
              }
              return false;
            });
    }

    return 'already_saved';
  }

  getFileData(mathLevel: number, studentFirebaseId = null) {
    if (this.openCancelStash?.fileId === this.fileId) {
      this.currentFileData = JSON.parse(this.openCancelStash!.json);
    }
    this.openCancelStash = null;
    if (this.fileId) {
      if (Object.keys(this.currentFileData).length) {
        // * If user reload the page then this code block will run

        let isFileViewable = false;
        const currentAssignmentData: any = this.assignmentService.getFileData();

        if (currentAssignmentData && currentAssignmentData?.assignmentStatus !== 'ASSIGNED') {
          const userDetails = this.sessionManagerService.getLoggedInData();

          if (userDetails?.userType === '1' || userDetails?.userType === '2' || userDetails?.userType === '4') {
            const { student } = currentAssignmentData!.assignmentPermissions;

            if ((!student.canEdit && student.canView) || (!student.canEdit && !student.canView)) {
              isFileViewable = true;
              this.assignmentService.fileModeSubject.next(true);
            }
          } else if (userDetails?.userType === '3') {
            const { teacher } = currentAssignmentData!.assignmentPermissions;

            if (!teacher.canEdit && teacher.canView) {
              isFileViewable = true;
              this.assignmentService.fileModeSubject.next(true);
            }
          }
        }

        // * CHECK IF FILE IS ASSIGNED TO STUDENT BUT TEACHER MARKS IT TRASH AND THEN OPEN IT
        if (currentAssignmentData && currentAssignmentData?.assignmentStatus === 'ASSIGNED') {
          const userDetails = this.sessionManagerService.getLoggedInData();
          if (userDetails?.userType === '3') {
            isFileViewable = true;
            this.assignmentService.fileModeSubject.next(true);
          }
        }

        let image = '';
        let bitmap = null;
        if (this.currentFileUrl) {
          this.commonService.setCanvasBackgroundColor(CV_COLOR_1);
          const isPdf = this.isPdf(this.currentFileUrl);
          image = !isPdf ? (this.parsedCurrentFile as string) : '';
          bitmap = isPdf ? (this.parsedCurrentFile as string[]) : null;
        }

        this.openFileWithData(mathLevel, image, bitmap, isFileViewable);
        this.startSavingData();
      } else {
        this.isFileLoading = true;
        this.loaderService.start();
        (forkJoin({
          firebaseData: studentFirebaseId
            ? this.firebaseAuthService.getStudentFile(this.fileId, studentFirebaseId)
            : this.firebaseAuthService.getData(this.fileId),
          bData: this.getFileDetails(),
        }).subscribe(
          async res => {
            this.loadFailed = false;
            let fdata = res.firebaseData.data();
            let isFileViewable = false;

            if (fdata?.canvasPreviewState && fdata.canvasPreviewState?.assignmentStatus !== 'ASSIGNED') {
              const lastSnapshot = fdata.canvasPreviewState;
              const userDetails = this.sessionManagerService.getLoggedInData();

              if (userDetails?.userType === '1' || userDetails?.userType === '2' || userDetails?.userType === '4') {
                const { student } = lastSnapshot!.assignmentPermissions;

                if (!student.canEdit && student.canView) {
                  isFileViewable = true;
                  fdata = lastSnapshot;
                  fdata!.assignmentCase = res.bData.data.assignmentCase;
                  this.assignmentService.setFileData(fdata);
                  this.assignmentService.fileModeSubject.next(true);
                } else if (student.canEdit && student.canView) {
                  this.assignmentService.setFileData(res.bData.data);
                }
              } else if (userDetails?.userType === '3') {
                const { teacher } = lastSnapshot!.assignmentPermissions;

                if (!teacher.canEdit && teacher.canView) {
                  isFileViewable = true;
                  fdata = lastSnapshot;
                  this.assignmentService.fileModeSubject.next(true);
                }
              }
            }

            const currentAssignmentData: any = this.assignmentService.getFileData();

            if (fdata?.canvasPreviewState && fdata.canvasPreviewState?.assignmentStatus === 'ASSIGNED' && !currentAssignmentData) {
              this.assignmentService.setFileData({
                assignmentPermissions: fdata?.canvasPreviewState?.assignmentPermissions,
                assignmentStatus: fdata?.canvasPreviewState?.assignmentStatus,
                assignmentCase: res.bData.data.assignmentCase,
              });
            }

            if (
              (fdata?.canvasPreviewState && fdata.canvasPreviewState?.assignmentStatus === 'ASSIGNED') ||
              currentAssignmentData?.assignmentStatus === 'ASSIGNED'
            ) {
              const userDetails = this.sessionManagerService.getLoggedInData();
              if (userDetails?.userType === '3') {
                isFileViewable = true;
                this.assignmentService.fileModeSubject.next(true);
              }
            }

            this.currentFileData = fdata ? fdata : {};

            this.currentFileUrl = res.bData.data.fileLocation?.location;
            if (this.currentFileUrl) {
              this.commonService.setCanvasBackgroundColor(CV_COLOR_1);
            }

            const image = await this.getBase64Image(res.bData.data.fileLocation?.location);
            const bitmap = await this.getPdfPages(res.bData.data.fileLocation?.location);
            this.parsedCurrentFile = image ? image : bitmap ? bitmap : '';
            this.openFileWithData(mathLevel, image, bitmap, isFileViewable);
            this.isFileLoading = false;
            this.startSavingData();

            const fileName = res.bData.data?.assignmentId ? filterDateTimeStamp(res.bData.data?.assignmentId?.title) : res.bData.data.fileName;
            this.currentFileName$.next(fileName);
            this.loaderService.stop();
          },
          err => {
            // Usually means the Firebase session is not established (or was torn down) before this read.
            // Log enough context to tell that apart from a genuine rules failure.
            console.error('[FileManagerService getFileData] Firestore read denied', {
              message: err?.message,
              fileId: this.fileId,
              firebaseUserId: this.sessionManagerService.getFirebaseUserId(),
              hasSession: this.sessionManagerService.isSession(),
            });
            this.loadFailed = true;
            this.isFileLoading = false;
            this.loaderService.stop();
            const errorKey = err?.status === Constants.ERROR_CODES.NOT_ACCEPTABLE ? 'ERROR.assignmentNoLongerAvailable' : 'ERROR.somethingWentWrong';
            this.translateService.get(errorKey).subscribe((translatedMessage: string) => {
              this.flashService.showError(translatedMessage);
            });
          },
        ),
          (error: any) => {
            this.loaderService.stop();
            console.log('[FileManagerService getFileData] Error: ', error.message);
          });
      }
    } else {
      cvNewFile(mathLevel, '', '', null, false, false, this.sessionManagerService.getAnalyticsType());
      this.createNewFile().subscribe();
      this.startSavingData();
    }
  }

  async getFileDataAfterSaveAsAction(mathLevel: number) {
    if (this.fileId) {
      this.loaderService.start();

      try {
        const res: any = await forkJoin({
          firebaseData: this.firebaseAuthService.getData(this.fileId),
          bData: this.getFileDetails(),
        }).toPromise();

        console.log('RESPONSE->', res.firebaseData.data(), res.bData);

        this.loadFailed = false;
        const fdata = res.firebaseData.data();
        this.currentFileData = fdata ? fdata : {};
        this.currentFileUrl = res.bData.data.fileLocation?.location;
        const image = await this.getBase64Image(res.bData.data.fileLocation?.location);
        const bitmap = await this.getPdfPages(res.bData.data.fileLocation?.location);
        this.parsedCurrentFile = image ? image : bitmap ? bitmap : '';

        console.log('DATA', mathLevel, image, bitmap);

        this.openFileWithData(mathLevel, image, bitmap);
        this.currentFileName$.next(res.bData.data.fileName);
        this.loaderService.stop();
        this.startSavingData();
        return true;
      } catch (err: any) {
        this.loadFailed = true;
        this.loaderService.stop();
        this.startSavingData();
        console.log('[FileManagerService SaveAs] Error: ', err.message);
        return false;
      }
    }

    return null;
  }
  // Open Google Drive File - PDF/JPEG/JPG/PNG
  openGoogleDriveFile(mathlevel: any, googleDriveFileId: any) {
    const tempIsIntegratedWithGoogle = this.sessionManagerService.getisIntegratedWithGoogle();
    if (tempIsIntegratedWithGoogle !== 'true') {
      // Only say "removed" when it demonstrably was. Mid-logout the flag is simply gone, and the
      // update banner already explains what happened.
      if (this.sessionManagerService.isGoogleIntegrationRemoved()) {
        this.translateService.get('googleIntegrationRemovedError').subscribe((translatedMessage: string) => {
          this.flashService.showError(translatedMessage);
        });
      }
      return;
    }
    // fileId is set before the canvas holds the file, so saves wait until it is opened.
    this.isFileLoading = true;
    this.loaderService.start();
    // Logic To Check Current Request Google Drive/Classroom File - Already Opened In Kiwiwrite Or Not
    this.requestService.post(Constants.ENDPOINTS.getGoogleDriveFileDetails, { googleDriveFileId: googleDriveFileId }).subscribe(
      (result: any) => {
        if (result.data.googleDriveFilesDetails.length > 0) {
          this.currentFileUrl = result?.data?.googleDriveFilesDetails[0]?.fileLocation?.location
            ? result?.data?.googleDriveFilesDetails[0]?.fileLocation?.location
            : '';
          // File Records Found in KiwiWrite
          const data = {
            googleDriveFileId: result.data.googleDriveFilesDetails[0].googleDriveFileId,
            firebaseFileId: result.data.googleDriveFilesDetails[0].firebaseFileId,
            userid: result.data.googleDriveFilesDetails[0].firebaseFileId,
            key: result.data.googleDriveFilesDetails[0].fileLocation.key,
          };
          this.updateGoogleDriveFileID(
            result.data.googleDriveFilesDetails[0].firebaseFileId,
            result.data.googleDriveFilesDetails[0].googleDriveFileId,
            result.data.googleDriveFilesDetails[0].id,
          );
          this.requestService.post(Constants.ENDPOINTS.getGoogleDriveFileFromS3, data).subscribe(
            (res: any) => {
              this.getGoogleDriveFirebaseData(result.data.googleDriveFilesDetails[0].firebaseFileId, mathlevel, res.file);
              this.currentFileName$.next(result.data.googleDriveFilesDetails[0].fileName);
              if (res.pdfPageLimitWarning) {
                this.translateService.get('ERROR.googleDriveFilePageWarning').subscribe((translatedMessage: string) => {
                  this.flashService.showError(translatedMessage);
                });
                this.router.navigate([`${CANVAS_DASHBOARD.URL}/${this.sessionManagerService.getUserMathLevelId().matheLevelNo}`], {
                  state: { disabledMostRescentBox: true },
                });
              }
              this.loaderService.stop();
            },
            error => {
              this.isFileLoading = false;
              this.loaderService.stop();
              if (error.status == 560 || error.errorMessage == 'Sorry your free trial has expired.') {
                this.sessionLogout();
              }
              this.clearCanvasDataAndStates();
              this.router.navigate([`${CANVAS_DASHBOARD.URL}/${this.sessionManagerService.getUserMathLevelId().matheLevelNo}`], {
                state: { disabledMostRescentBox: true },
              });
            },
          );
          // Save Lastest File Data while Opening Existing Google File
          this.checkFirebaseEntry(result.data.googleDriveFilesDetails[0].firebaseFileId);
        } else {
          // File Records Not Found in KiwiWrite // Get Google Drive/Classroom File Information // Save the Google Drive/Classroom Files to Kiwiwrite S3 Bucket
          // Create Firebase Record
          this.firebaseAuthService
            .addData({})
            .then(fRes => {
              if (!fRes.id) {
                this.isFileLoading = false;
                this.loaderService.stop();
                return;
              }
              const requestNewGoogleDriveFile = async (attempt = 0) => {
                // Drop the overlay first. It is full-screen and eats pointer events, so holding it
                // here made the "Tap to continue" prompt untappable — and on iPad that tap is the
                // only way a token can arrive. The app hung until the wait expired.
                this.loaderService.stop();
                const accessToken = await this.waitForGoogleAccessToken();
                if (!accessToken) {
                  this.isFileLoading = false;
                  // Already stopped above — the overlay is down and stays down.
                  console.log('requestNewGoogleDriveFile: access token unavailable after retries');
                  this.translateService.get('ERROR.googleFileNotAvailableNow').subscribe((translatedMessage: string) => {
                    this.flashService.showError(translatedMessage);
                  });
                  this.clearCanvasDataAndStates();
                  this.router.navigate([`${CANVAS_DASHBOARD.URL}/${this.sessionManagerService.getUserMathLevelId().matheLevelNo}`], {
                    state: { disabledMostRescentBox: true },
                  });
                  return;
                }
                this.loaderService.start();
                const data = {
                  googleDriveFileId: googleDriveFileId,
                  mathLevel: this.sessionManagerService.getUserMathLevelId().mathLevelId,
                  accesstoken: accessToken,
                  kiwiWriteUserId: this.sessionManagerService.getUserId(),
                  firebaseFileId: fRes.id,
                  fileStatus: Constants.FILE_STATUS.NOT_DONE,
                };

                this.requestService.post(Constants.ENDPOINTS.getNewGoogleDriveFile, data).subscribe(
                  (res: any) => {
                    console.log('requestNewGoogleDriveFile: success on attempt', attempt);
                    this.updateGoogleDriveFileID(res.firebaseFileId, res.googleDriveFileId, res.id);
                    cvNewFile(
                      this.sessionManagerService.getUserMathLevelId().matheLevelNo,
                      '',
                      res.file,
                      null,
                      false,
                      false,
                      this.sessionManagerService.getAnalyticsType(),
                    );
                    this.isFileLoading = false;
                    this.currentFileName$.next(res.googleDriveFileName);
                    if (res.pdfPageLimitWarning) {
                      this.translateService.get('ERROR.googleDriveFilePageWarning').subscribe((translatedMessage: string) => {
                        this.flashService.showError(translatedMessage);
                      });
                      this.router.navigate([`${CANVAS_DASHBOARD.URL}/${this.sessionManagerService.getUserMathLevelId().matheLevelNo}`], {
                        state: { disabledMostRescentBox: true },
                      });
                    }
                    this.loaderService.stop();
                  },
                  error => {
                    // The backend answers 504 for a genuine Drive timeout *and* for rejected
                    // credentials, so only retry while the token is still good — otherwise the
                    // retry is guaranteed to fail the same way and just delays the message.
                    if (error?.status === 504 && attempt < 2 && Number(localStorage.getItem('lastGeneratedAccessTokenExpires') || 0) > Date.now()) {
                      console.log('requestNewGoogleDriveFile: 504 timeout, retrying...', { attempt: attempt + 1 });
                      setTimeout(() => {
                        void requestNewGoogleDriveFile(attempt + 1);
                      }, 2000);
                      return;
                    }
                    console.log('requestNewGoogleDriveFile: failed', { attempt, status: error?.status, error });
                    this.isFileLoading = false;
                    this.loaderService.stop();
                    if (error.status == 560 || error.errorMessage == 'Sorry your free trial has expired.') {
                      this.sessionLogout();
                    }
                    this.clearCanvasDataAndStates();
                    this.router.navigate([`${CANVAS_DASHBOARD.URL}/${this.sessionManagerService.getUserMathLevelId().matheLevelNo}`], {
                      state: { disabledMostRescentBox: true },
                    });
                  },
                );
              };

              void requestNewGoogleDriveFile();
            })
            .catch(err => {
              // Without this the overlay outlived a failed Firebase write and the screen stayed
              // dimmed and unresponsive with no message at all.
              this.isFileLoading = false;
              this.loaderService.stop();
              console.log('openGoogleDriveFile: could not create the Firebase record', err);
              this.translateService.get('ERROR.somethingWentWrong').subscribe((translatedMessage: string) => {
                this.flashService.showError(translatedMessage);
              });
            });
        }
      },
      error => {
        this.isFileLoading = false;
        this.loaderService.stop();
        if (error.status == 560 || error.errorMessage == 'Sorry your free trial has expired.') {
          this.sessionLogout();
        }
        console.log('parent error', error);
        this.translateService.get('ERROR.googleFileNotAvailableNow').subscribe((translatedMessage: string) => {
          this.flashService.showError(translatedMessage);
        });
      },
    );
  }

  // Check the Firebase File id and data
  checkFirebaseEntry(fileId: any) {
    try {
      const data = this.firebaseAuthService.getData(fileId);
      if (!data) {
        this.firebaseAuthService.reCreateFirebaseDocument(this.fileId);
      }
    } catch (error) {
      console.error('Error in getOrCreateFirebaseEntry:', error);
      throw error;
    }
  }

  // Get Google Drive File Edited information
  getGoogleDriveFirebaseData(firebaseFileId: any, mathLevel: any, googleDriveBitmap: any) {
    forkJoin({
      firebaseData: this.firebaseAuthService.getData(firebaseFileId),
    }).subscribe(
      async res => {
        const fdata = res.firebaseData.data();
        this.currentFileData = fdata ? fdata : {};
        this.parsedCurrentFile = googleDriveBitmap;
        this.openFileWithData(mathLevel, '', googleDriveBitmap);
        this.isFileLoading = false;
      },
      () => {
        this.loadFailed = true;
        this.isFileLoading = false;
      },
    );
  }

  openFileWithData(mathLevel: number, fileUrl?: string, bitmap?: string[] | null, viewOnly = false) {
    const fromCancel = sessionStorage.getItem('fromCancel') ? JSON.stringify(sessionStorage.getItem('fromCancel')) : false;
    sessionStorage.removeItem('fromCancel');
    try {
      cvNewFile(
        mathLevel,
        fileUrl,
        bitmap ? bitmap : '',
        // A stored doc with no `mathProblem` is not a canvas file. An assignment created from a
        // file whose canvas had not been written yet copies through as `{ teacherId,
        // canvasPreviewState }`, and handing that to the canvas throws inside cvOpenFile before
        // the stage background and mouse handlers attach — the file renders nothing and the math
        // keys do nothing. Every genuinely saved file has `mathProblem` (MathFileType always sets
        // it, even with no math), so this only ever catches that wrapper and opens it as the blank
        // canvas over the imported page that it actually is.
        Object.keys(this.currentFileData).length === 0 || !('mathProblem' in this.currentFileData) ? null : JSON.stringify(this.currentFileData),
        fromCancel,
        viewOnly,
        this.sessionManagerService.getAnalyticsType(),
      );
    } catch (err) {
      this.loaderService.stop();
    }
  }

  startSavingData() {
    // Every file open called this, stacking a new timer on top of the last one.
    this.stopFileSaveOnInterval();
    this.fileSaveInterval = setInterval(() => {
      this.saveFileData();
    }, Constants.FILE_SAVE_INTERVAL);
  }

  stopFileSaveOnInterval() {
    clearInterval(this.fileSaveInterval);
  }

  extractFileNameWithoutExtension(fullFileName: string, maxLength = 100): string {
    if (!fullFileName) {
      return this.generateFileName();
    }

    // Remove file extension
    const lastDotIndex = fullFileName.lastIndexOf('.');
    const nameWithoutExtension = lastDotIndex > 0 ? fullFileName.substring(0, lastDotIndex) : fullFileName;

    // Truncate if exceeds max length
    return nameWithoutExtension.length > maxLength ? nameWithoutExtension.substring(0, maxLength) : nameWithoutExtension;
  }

  generateFileName() {
    return 'Math File ' + new Date().toString().split('GMT')[0];
  }

  changeStatusOfFile(status: string): Observable<IFileResponse> {
    if (this.router.url.indexOf('/drive') > -1) {
      const googleDriveKiwiFileId = this.sessionManagerService.getGoogleFileId().googleDriveKiwiFileId;
      return this.requestService.patch(`${Constants.ENDPOINTS.files}/${googleDriveKiwiFileId}/status/${status}`);
    } else {
      return this.requestService.patch(`${Constants.ENDPOINTS.files}/${this.bFileId}/status/${status}`);
    }
  }
  renameFile(name: string, isAssignmentFile?: boolean, firebaseFileId?: null) {
    const data: { fileName: string; isAssignmentFile?: boolean } = {
      fileName: name,
    };
    if (isAssignmentFile) {
      data.isAssignmentFile = true;
    }
    return firebaseFileId
      ? this.requestService.patch(`${Constants.ENDPOINTS.files}/${firebaseFileId}/name`, data)
      : this.requestService.patch(`${Constants.ENDPOINTS.files}/${this.bFileId}/name`, data);
  }

  renameGoogleDriveFile(name: string, googleDriveFileId: string, accessToken: string) {
    const data = {
      fileName: name,
      googleDriveId: googleDriveFileId,
      accessToken: accessToken,
    };
    return this.requestService.post(`${Constants.ENDPOINTS.files}/rename-google-drive-file`, data);
  }

  checkGoogleAccessToke(accessToken: string) {
    const data = {
      accessToken: accessToken,
    };
    return this.requestService.post(`${Constants.ENDPOINTS.files}/check-google-access-token`, data);
  }

  checkEmailDomain(email: any) {
    const data = {
      email: email,
    };
    return this.requestService.post(`${Constants.ENDPOINTS.files}/check-email-domain`, data);
  }

  getFileDetails() {
    return this.requestService.get<any>(`${Constants.ENDPOINTS.files}/${this.bFileId}/details`);
  }

  getGoogleFileDetails(id: string) {
    return this.requestService.post<any>(`${Constants.ENDPOINTS.getGoogleDriveFileIdDetails}`, {
      googleDriveFileId: id,
    });
  }

  uploadAFile(file: File) {
    const formData = new FormData();
    formData.append('image', file);
    if (!this.isFileDataAvailable() && this.bFileId) {
      formData.append('fileId', this.bFileId);
    }
    return this.requestService.post(`${Constants.ENDPOINTS.files}/upload-file`, formData);
  }

  uploadAGoogleDriveFile(file: File) {
    const formData = new FormData();
    formData.append('image', file);
    if (!this.isFileDataAvailable()) {
      formData.append('fileId', this.bFileId);
    }
    return this.requestService.post(`${Constants.ENDPOINTS.files}/upload-file`, formData);
  }

  getBase64Image(url: string): Promise<string> {
    return new Promise(resolve => {
      if (url && !this.isPdf(url)) {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
          const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
          const ctx = canvas.getContext('2d');
          canvas.height = img.height;
          canvas.width = img.width;
          ctx?.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        // An image that 404s or stored empty fires `error`, never `load`. Without this the promise
        // never settled and every caller awaiting it stalled behind the loader.
        img.onerror = () => {
          console.error('[FileManagerService] Could not load the stored image:', url);
          this.loaderService.stop();
          resolve('');
        };
        img.src = url;
      } else {
        this.loaderService.stop();
        resolve('');
      }
    });
  }

  getPdfPages(url: string): Promise<string[] | null> {
    return new Promise(resolve => {
      if (url && this.isPdf(url)) {
        pdfjsLib
          .getDocument({ url, isEvalSupported: false })
          .promise.then(async (pdf: any) => {
            const bitmaps = await this.generateBitmap(pdf);
            resolve(bitmaps);
          })
          .catch((err: any) => {
            // Resolve rather than reject: callers treat "no pages" as "nothing to draw", and an
            // unhandled rejection here left the loader up with no explanation.
            console.error('[FileManagerService] Could not read the stored PDF:', err);
            this.loaderService.stop();
            resolve(null);
          });
      } else {
        this.loaderService.stop();
        resolve(null);
      }
    });
  }

  /**
   * Renders every page of a PDF to a JPEG data URL.
   *
   * Rewritten to settle on every path. The previous version hung outright when `numPages` was 0 —
   * the loop body never ran, so nothing ever resolved — and swallowed a rejected `getPage()` the
   * same way. Both are reachable from a PDF that stored empty, which is exactly what the iPadOS
   * import bug produced, and both presented as the import freezing at 98%.
   */
  generateBitmap(pdf: any): Promise<string[]> {
    this.totalPageInPdf = pdf.numPages;

    if (!pdf.numPages) {
      return Promise.reject(new Error('The PDF reported no pages.'));
    }

    const renderPage = async (pageNumber: number): Promise<string> => {
      const page = await pdf.getPage(pageNumber);
      const viewport = page.getViewport({ scale: 1.3 });

      // Prepare canvas using PDF page dimensions
      const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
      const context = canvas.getContext('2d') as CanvasRenderingContext2D;
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render PDF page into canvas context
      await page.render({ canvasContext: context, viewport }).promise;
      return canvas.toDataURL('image/jpeg');
    };

    return Promise.all(Array.from({ length: pdf.numPages }, (_, i) => renderPage(i + 1)));
  }

  isPdf(url: string) {
    const temp = url.split('.');
    return temp[temp.length - 1] === 'pdf';
  }

  getUserPreferences() {
    return this.sessionManagerService.getUserPreferences();
  }

  resetCurrentData() {
    this.currentFileData = {};
    this.openCancelStash = null;
    this.parsedCurrentFile = '';
    this.currentFileUrl = '';
  }
  updateDataFormSession() {
    const data = JSON.parse(sessionStorage.getItem('canvasDataOnrefresh') as string);
    //console.log('data', JSON.parse(data.canvasData));

    this.currentFileUrl = data.importFile;
    this.parsedCurrentFile = JSON.parse(data.parsedImportFile);
    this.updateCurrentFileData(data.canvasData);
    this.currentFileName$.next(data.fileName);
    this.totalPageInPdf = data.totalpage;
    this.saveFileData(true);
    sessionStorage.removeItem('canvasDataOnrefresh');
  }
  isFileDataAvailable() {
    return !!(Object.keys(this.getCurrentFileData()).length || this.currentFileUrl);
  }
  isFileReady() {
    return !this.isFileLoading && !this.loadFailed;
  }
  updateFileData(location: string, binaryUrlImage = '', bitmaps?: string[] | null) {
    this.currentFileUrl = location;
    this.parsedCurrentFile = binaryUrlImage ? binaryUrlImage : bitmaps ? bitmaps : '';
  }

  sessionLogout(isNewFileCreated?: boolean) {
    this.translateService.get('ERROR.accountExpired').subscribe((translatedMessage: string) => {
      this.flashService.showError(translatedMessage);
    });
    this.saveLastFileDetails().subscribe();
    this.saveFileData(false, isNewFileCreated);
    this.requestService.patch(Constants.ENDPOINTS.logout).subscribe(() => {
      localStorage.removeItem('login');
      localStorage.removeItem('preferences');
      localStorage.removeItem('redirectionURL');
      this.sessionManagerService.logout();
      this.firebaseAuth.logOutfromFirebase();
      this.azureAuth.logOutfromAzure();
      this.sessionManagerService.setPriceId('free_trial' as string);
      this.router.navigate([USER_HOME.URL]).then(() => {
        this.resetCurrentData();
      });
    });
  }
  //  start main logic
  exportAsKiwi() {
    this.loaderService.start();

    const fileIdAndBFileId =
      this.sessionManagerService.getFileIdAndBFileId() && !this.router.url?.includes('/student/drive')
        ? this.sessionManagerService.getFileIdAndBFileId()
        : {};

    let googleFileData: {
      fileId: string;
      googleDriveFileid: string;
      googleDriveKiwiFileId: string;
    } | null = null;
    if (Object.values(fileIdAndBFileId).length === 0) {
      googleFileData = this.sessionManagerService.getGoogleFileId();
    }

    if (this.currentFileUrl || googleFileData) {
      this.requestService
        .get(`${Constants.ENDPOINTS.files}/${googleFileData ? googleFileData.googleDriveKiwiFileId : this.bFileId}/getbse64`)
        .subscribe(
          (res: any) => {
            this.createAndDownloadKiwiFile(res.base64Data);
            this.loaderService.stop();
            this.modalService.hide();
          },
          error => {
            console.error('error', error);
            this.loaderService.stop();
          },
        );
    } else {
      this.createAndDownloadKiwiFile(null);
      this.loaderService.stop();
      this.modalService.hide();
    }
  }
  filterDateTimeStamp(dateString: string): string {
    const regex = /[a-zA-Z]{3} [a-zA-Z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2}/;
    return dateString.replace(regex, '').trim();
  }

  createAndDownloadKiwiFile(pdfOrImageData: string | null) {
    let fileName = this.getCurrentFileName();
    fileName = this.filterDateTimeStamp(fileName);

    if (/\.[a-zA-Z0-9]+$/.test(fileName)) {
      fileName = fileName.replace(/\.[a-zA-Z0-9]+$/, ''); // Removes only a valid extension
    }
    const dataToExport = {
      mathKeys: this.currentFileData,
      fileName: fileName,
      pdfOrImageData: pdfOrImageData,
      mathLevelId: this.sessionManagerService.getUserMathLevelId().mathLevelId,
    };
    const jsonString = JSON.stringify(dataToExport);
    const blob = new Blob([jsonString], { type: 'application/kiwi' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.kiwi`;
    link.click();
    // Cleanup
    URL.revokeObjectURL(link.href);
  }

  clearCanvasDataAndStates() {
    const { matheLevelNo } = this.sessionManagerService.getUserMathLevelId();
    this.resetCurrentData();
    cvNewFile(matheLevelNo, '', '', null, false, false, this.sessionManagerService.getAnalyticsType());
  }
}
